import request from "./request"

export const getDecorationCatalog = params => request({ url: "/decoration/catalog_get", method: "get", params })
export const getOwnedDecorations = () => request({ url: "/decoration/owned_get", method: "get" })
export const purchaseDecoration = data => request({ url: "/decoration/purchase_add", method: "post", data })
export const equipDecoration = data => request({ url: "/decoration/equip_update", method: "post", data })
